import { WheelSection } from '../types/goals';

export const DEFAULT_WHEEL_SECTIONS: WheelSection[] = [
  { id: 'health',        name: 'Health',       color: '#4ade80', rating: 0 },
  { id: 'career',        name: 'Career',       color: '#60a5fa', rating: 0 },
  { id: 'finances',      name: 'Finances',     color: '#fbbf24', rating: 0 },
  { id: 'growth',        name: 'Growth',       color: '#c084fc', rating: 0 },
  { id: 'family',        name: 'Family',       color: '#f87171', rating: 0 },
  { id: 'relationships', name: 'Love',         color: '#f472b6', rating: 0 },
];
